import { useMemo } from 'react'
import { SpecialHolidayType, TemporaryOpenDate } from 'types/calendar'
import { parseToDate } from 'lib/helper'
import { CheckoutItemType } from 'types/checkoutItem'
import { StoreCalendarType } from 'types/storeCalendar'
import { DayOfWeekType, DaysOfWeek } from 'lib/daysOfWeek'
const daysOfWeek = new DaysOfWeek()

const useConfirmTemporaryOpenDates = (
  checkoutItems: CheckoutItemType[],
  storeCalendars: StoreCalendarType[],
  addedHolidays: DayOfWeekType[],
  specialHolidays: SpecialHolidayType[]
): TemporaryOpenDate[] => {
  return useMemo(() => {
    const dates: TemporaryOpenDate[] = []
    if (!checkoutItems || !storeCalendars || !addedHolidays) return dates
    const openStoreCalendars = storeCalendars.filter((storeCalendar) => {
      return storeCalendar.status === 'open'
    })
    for (let i = 0; i < checkoutItems.length; i = (i + 1) | 0) {
      const checkoutItem = checkoutItems[i]
      const orderedDate = parseToDate(checkoutItem.date)
      // 定休日に追加されたが注文のある日付は臨時営業日に設定する
      // すでに臨時営業日に設定されている場合は除外する
      if (
        !addedHolidays.includes(daysOfWeek.getDayOfWeek(orderedDate, specialHolidays)) ||
        openStoreCalendars.some((openStoreCalendar) => {
          return openStoreCalendar.date === checkoutItem.date
        })
      )
        continue
      dates.push({ breadRef: checkoutItem.bread_ref, date: orderedDate })
    }
    return dates
  }, [checkoutItems, storeCalendars, addedHolidays])
}

export default useConfirmTemporaryOpenDates
